/*
----------------------------
Module - regional-office-carousel
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';
    
    fmg.officeCarousel = function () {

        function setupRegionButtons() {

            var $region_btn = $(".regional-office-carousel__region-btn");

            var $back_btn = $(".regional-office-carousel__back-btn");

            $region_btn.on("click", function(e){

                var $this = $(this);

                var office_id = $this.data("offices");

                // Pass in the parent folder id
                showOffices(office_id, e.detail);

            });

            $back_btn.on("click", function(e){

                var event_type = e.detail;

                hideOffices(event_type);

            })

        }

        function scrollToTop() {

            // Scroll to the top of the carousel
            $("html,body").animate({

                scrollTop: $carousel.offset().top - 120

            });

        }

        function showOffices(id, event_type) {

            var $selected_office = $offices.filter("[data-offices='"+id+"']");

            var screen_size = fmg.vars.screensize;

            $offices.removeClass("fadeOutRight");

            $islands.removeClass("fadeInLeft").addClass("fadeOutLeft"); 

            $selected_office.removeClass("fadeOutLeft").addClass("fadeInRight");

            // If keypress
            if(event_type == 0) {
                $selected_office.find(".regional-office-carousel__back-btn").trigger("focus");
            }

            // Run scroll 
            if(screen_size == 1) {

                scrollToTop();

            }

        }

        function hideOffices(event_type) {

            var $current_office = $offices.filter('.fadeInRight');

            var current_office_id = $current_office.data("offices");

            var $current_region_btn = $(".regional-office-carousel__region-btn").filter("[data-offices='" + current_office_id + "']");

            var screen_size = fmg.vars.screensize;

            $offices.removeClass("fadeOutRight");
            
            $islands.removeClass("fadeOutLeft").addClass("fadeInLeft");

            $current_office.removeClass("fadeInRight").addClass("fadeOutRight");

            // If keypress
            if(event_type == 0) {
                $current_region_btn.trigger("focus");
            }

            // Run scroll 
            if(screen_size == 1) {

                scrollToTop();

            }

        }

        function init() {

            var $carousel = $(".regional-office-carousel");

            if($carousel.length) {

                setupRegionButtons();

            }

        }

        var $carousel = $(".regional-office-carousel");
        var $islands = $(".regional-office-carousel__islands");
        var $offices = $(".regional-office-carousel__offices");
        
        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.officeCarousel.init();
    });
    
}());
